import mapboxgl from 'mapbox-gl';

mapboxgl.workerClass =
    // eslint-disable-next-line
    require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
